// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"l5-z"};